import React from "react"
import { Button as AntdButton } from "antd"
import styles from "./button.scss"

export const Button = ({ children, ...props }) => {
  return (
    <AntdButton
    {...props}
    className={`${styles.button} ${props.className || ""}`}
    >
      {children}
    </AntdButton>
  )
}



// WEBPACK FOOTER //
// ./src/components/Button/Button.tsx